// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Shipment } from '@/shipment/api/types';

/**
 * Returns true when a shipment contains at least one item that is not on the
 * fulfillment order's item set.
 */
export function shipmentHasExtraItems(
  shipment: Shipment,
  foItemIds: Set<string>
): boolean {
  return shipment.items.some((item) => !foItemIds.has(item.id));
}
